import * as d3 from 'd3-fetch';
import * as turf from '@turf/turf';
import categoryNames from '@/categoryNames';
import { EventBus } from '@/EventBus';

const locationsDataPromise = d3.csv(
    'https://docs.google.com/spreadsheets/d/e/2PACX-1vQvleSEA47Rq8jjWbL-BDqCUhC6A10yWxktoWywc9tmvnDPRH7XamzjwYy3Mhzp_VFRvVyzCWf7S_Fj/pub?gid=0&single=true&output=csv'
);

const orgsDataPromise = d3.csv(
    'https://docs.google.com/spreadsheets/d/e/2PACX-1vQai8-aOT2EKMtM__JmZggcYQGDEt1dwmoerT85gXczlvQ7sdsqB2iyBuHIgn6kBWbgR7Ix1jxAZfHr/pub?output=csv'
);

function orgsCsvToServicePoints(rows) {
    // clean up an object of { transport: 'x', tasks: 'X ', plan: ''} to { transport: true, tasks: true }
    function categoryColumns(row) {
        return Object.keys(categoryNames).reduce((cats, catName) => {
            if ((row[catName] || '').match(/x/i)) {
                cats[`category:${catName}`] = true;
            }
            return cats;
        }, {});
    }
    return rows
        .map((row) =>
            turf.point([+row.longitude, +row.latitude], {
                type: 'organisation',
                orgId: row.id.trim(),
                orgName: row.name.trim(),
                orgAddress: row.address.trim(),
                orgUrl: row.url.trim(),
                orgPhone: row.phone.trim(),
                orgEmail: row.email.trim(),
                orgLogo: row.logo.trim(),
                ...categoryColumns(row),
            })
        )
        .filter((org) => org.geometry.coordinates[0] !== 0);
}
/*
Breaks out the spreadsheet of communities with info about which organisations provide which services where.
*/
function locationsCsvToServicePoints(locations, orgsTable) {
    // split a list of "transport; tasks" to { transport: true, tasks: true }
    function categoryBooleans(categoryList) {
        return categoryList
            .split(/[^a-z-]+/)
            .filter(Boolean)
            .reduce(
                (obj, category) => ({ ...obj, [`category:${category}`]: true }),
                {}
            );
    }
    function validService(servicePoint, categories) {
        return (
            Object.keys(categories).length > 0 &&
            servicePoint.geometry.coordinates[0] +
                servicePoint.geometry.coordinates[1] !==
                0
        );
    }
    const servicePoints = [];
    const orgIds = locations.columns.slice(4);
    // break out each community-location row into multiple points: one for each org providing a service in that location
    for (const location of locations) {
        for (const orgId of orgIds) {
            const categories = categoryBooleans(location[orgId]);
            const org = orgsTable[orgId];
            const servicePoint = turf.point(
                [+location.longitude, +location.latitude],
                {
                    type: 'servicePoint',
                    orgId: orgId.trim(),
                    orgName: org.name.trim(),
                    orgAddress: org.address.trim(),
                    orgUrl: org.url.trim(),
                    orgPhone: org.phone.trim(),
                    orgEmail: org.email.trim(),
                    orgLogo: org.logo.trim(),

                    locationName: location.name.trim(),
                    cats: location[orgId], //for data export
                    ...categories,
                }
            );
            if (validService(servicePoint, categories)) {
                servicePoints.push(servicePoint);
            }
        }
    }
    return servicePoints;
}

function orgTable(orgRows) {
    return orgRows.reduce(
        (orgsTable, org) => ({ ...orgsTable, [org.id]: org }),
        {}
    );
}

// this function produces a string that can be pasted into AirTable in "Service" page.
function makeExport(locationRows, orgRows) {
    window.sps = locationsCsvToServicePoints(locationRows, orgTable(orgRows))
        .map((f) =>
            [
                '"' + f.properties.orgName.trim() + '"',
                f.properties.locationName.trim(),
                f.properties.cats.replace(/;\s*/g, ','),
            ].join('\t')
        )
        .join('\n');
}
export default async function load() {
    const [orgRows, locationRows] = await Promise.all([
        orgsDataPromise,
        locationsDataPromise,
    ]);
    console.log(locationRows);
    const servicePoints = [
        ...orgsCsvToServicePoints(orgRows),
        ...locationsCsvToServicePoints(locationRows, orgTable(orgRows)),
    ];
    makeExport(locationRows, orgRows);
    servicePoints.forEach((sp, i) => {
        sp.id = i + 1;
        sp.properties.id = i + 1;
    });
    console.log(servicePoints);
    EventBus.$emit('servicePoints-loaded', servicePoints);
    window.app.servicePoints = servicePoints;
    return servicePoints;
}
